'use strict';

var react = require('../../../../../../node_modules/zustand/esm/react.cjs');

/**
 * Counter for generating unique snackbar IDs
 * @internal
 */ let snackbarCounter = 0;
/**
 * Zustand store hook for managing snackbar notifications globally
 * @internal - Use the `useSnackbar` hook instead for most use cases
 */ const useSnackbarStore = react.create((set, get)=>({
        messages: [],
        addMessage: (message)=>{
            const timestamp = Date.now();
            const id = `snackbar-${message.variant}-${timestamp}-${snackbarCounter++}`;
            const newMessage = {
                ...message,
                id,
                position: message.position || "bottomRight",
                createdAt: timestamp
            };
            set((state)=>({
                    messages: [
                        ...state.messages,
                        newMessage
                    ]
                }));
            // Auto-remove message after duration if specified and > 0
            if (message.duration && message.duration > 0) {
                setTimeout(()=>{
                    get().removeMessage(id);
                }, message.duration);
            }
            return id;
        },
        removeMessage: (id)=>{
            set((state)=>({
                    messages: state.messages.filter((message)=>message.id !== id)
                }));
        }
    }));

exports.useSnackbarStore = useSnackbarStore;
//# sourceMappingURL=snackbarStore.cjs.map
